export default __webpack_public_path__ + "static/media/Logo.92d41ef4.png";